import script from "./EventsMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventsMenu.vue?vue&type=script&lang=ts&setup=true"

import "./EventsMenu.vue?vue&type=style&index=0&id=90c99bb2&lang=css"

const __exports__ = script;

export default __exports__